export type DispatchTarget = { value: string; label: string };

export const DISPATCH_TARGET: Record<string, DispatchTarget> = {
  manufacturer: {
    value: "manufacturer",
    label: "기계 제조사",
  },
  epTp: {
    value: "epTp",
    label: "EP/TP",
  },
  endUser: {
    value: "endUser",
    label: "실사용자",
  },
};
